import { islandContainerClasses } from "@/constants/layout";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { Footer } from "@/layouts/Footer";
import { Header } from "@/layouts/Header";

type Props = { children: React.ReactNode };

export function AppLayout({ children }: Props) {
  const { logout, userProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isArticlePage = location.pathname.startsWith("/articles");

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
      // Optionally: show a toast or alert to the user here
    }
  };

  return (
    <main className="min-h-screen w-full flex flex-col bg-gradient-to-r from-brand-from via-brand-via to-brand-to text-gray-900 font-sans">
      <Header onLogout={handleLogout} userProfile={userProfile} />

      <div className="grow flex justify-center relative">
        {isArticlePage ? (
          // No island wrapper for article pages
          children
        ) : (
          // Island wrapper for all other authenticated pages
          <div
            className={`${islandContainerClasses} my-8 py-4 bg-white/10 backdrop-blur-2xl rounded-3xl shadow-md flex flex-col min-h-[80vh] sm:min-h-[60vh]`}
          >
            {children}
          </div>
        )}
      </div>

      <Footer />
    </main>
  );
}
